import DrawerComponent from './DrawerComponent';
import React from 'react';
import StaticContent from './StaticContent';

export interface ServicesComponentProps {
	slideout?: boolean;
	openByDefault?: boolean;
	servicesContent?: ServiceContent[];
	portalTargetId: string;
	translations: Translations;
	isFiveStarMemberPricingEnabled?: boolean;
}

function ServicesComponent({
	slideout,
	openByDefault,
	servicesContent,
	portalTargetId,
	translations,
	isFiveStarMemberPricingEnabled,
}: ServicesComponentProps) {

	if (slideout) {
		return (
			<DrawerComponent
				servicesContent={servicesContent}
				openByDefault={openByDefault}
				portalTargetId={portalTargetId}
				translations={translations}
				isFiveStarMemberPricingEnabled={isFiveStarMemberPricingEnabled}
			/>
		);
	}
	return (
		<StaticContent
			servicesContent={servicesContent}
			isFiveStarMemberPricingEnabled={isFiveStarMemberPricingEnabled}
		/>
	);
}

export default ServicesComponent;
